/**
 * Peças repetidas pelas seções da janela de dados do risco (#606, E2/E3).
 */

import React from 'react';
import { Box } from '@mui/material';

/** O ponto azul que marca, no rótulo, o campo que conta para a completude. */
export const PontoDaCompletude: React.FC = () => (
  <Box
    component="span"
    aria-hidden
    sx={{ display: 'inline-block', width: 8, height: 8, borderRadius: '50%', bgcolor: 'primary.main', mr: 0.75 }}
  />
);

/** Rótulo de campo com o ponto quando ele conta. */
export const RotuloQueConta: React.FC<{ texto: string; conta?: boolean }> = ({ texto, conta = true }) => (
  <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
    {conta && <PontoDaCompletude />}
    {texto}
  </Box>
);

